
import React from 'react';
import ControlledPageScroll from '../ControlledPageScroll';
import TopRightCornerMenu from '../TopRightCornerMenu';
import "./_PageTemplate.less";

interface PageTemplateProps { };

export const PageTemplate: React.FC<PageTemplateProps> = ({ children }) => {
    return (
        <ControlledPageScroll className="page-wrapper">
            <div className="page-container">
                <TopRightCornerMenu />
                {children}
            </div>
        </ControlledPageScroll>
    );
}
